<template>
    <grid-col>
        <grid-row cols="3" xs-cols="2">
            <grid-col>
                <ui-dash-infos
                    :number="dashInfosData.customersFromMonth.toString()"
                    icon="fal fa-user-chart"
                    text="Clientes cadastrados mês"
                    color="#a55eea"
                    :load="loadDashClient"/>
            </grid-col>
            <grid-col>
                <ui-dash-infos
                    icon="fal fa-calendar-alt"
                    :number="dashInfosData.tasksVisit.toString()"
                    text="Total de visitas no mês"
                    color="#59b0ff"
                    :load="loadDashVisits"
                    />
            </grid-col>
            <grid-col>
                <ui-dash-infos
                    icon="fal fa-hand-holding-usd"
                    :number="dashInfosData.dealsWon.toString()"
                    text="Vendas realizadas no mês"
                    color="#1dd1a1"
                    :load="loadDashSales"
                    />
            </grid-col>
            <grid-col>
                <ui-dash-infos
                    icon="fal fa-building"
                    :number="dashInfosData.products.toString()"
                    text="Empreendimentos"
                    :load="loadDashProducts"
                />
            </grid-col>
            <grid-col>
                <ui-dash-infos
                    icon="fal fa-handshake"
                    :number="dashInfosData.deals.toString()"
                    text="Total de Negócios"
                    :load="loadDashDeals"
                />
            </grid-col>
            <grid-col>
                <ui-dash-infos
                    icon="fal fa-tags"
                    :number="dashInfosData.reserves.toString()"
                    text="Reservas Realizadas"
                    :load="loadDashReserves"
                />
            </grid-col>
        </grid-row>
    </grid-col>
</template>

<script>

    import { uiDashInfos } from '@/components/ui'
    import { gridRow, gridCol }  from '@/components/ui/grid'
    import { customer, deal, task, product, reserve } from "@/services/axios"
    import helpers from '@/mixins/helpers'

    export default {
        mixins: [ helpers ],
        components: { 
            uiDashInfos,
            gridRow,
            gridCol,
        },
        data () {
            return {
                loadDashClient: true,
                loadDashSales: true,
                loadDashVisits: true,
                loadDashProducts: true,
                loadDashDeals: true,
                loadDashReserves: true,
                todaydate: null,
                dashInfosData: {
                    customersFromMonth: 0,
                    dealsWon: 0,
                    tasksVisit: 0,
                    products: 0,
                    deals: 0,
                    reserves: 0
                },
            }
            
        },
       
        methods: {
            getCustomersFromMonth() {
                const today = new Date()
                const params = {
                    year: today.getUTCFullYear()
                }
                customer.getAll('get-by-broker', params).then((response) => {
                        const customers = response.data.find((item) => item.month === (today.getUTCMonth() + 1))
                        this.dashInfosData.customersFromMonth = customers ? customers.count : 0
                        this.loadDashClient = false
                    })
            },
            getTasksVisit() {
                const params = {
                    actual_month: true,
                    type: 'visit',
                    count: true
                }
                task.getAll('', params).then((response) => {
                    this.dashInfosData.tasksVisit = response.data
                    this.loadDashVisits = false
                })
            },
            getDealsWon() {
                const params = {
                    owners: true,
                    funnel_stage_win_probability: 'won',
                    actual_month: true,
                    count: true
                }
                deal.getAll('', params).then((response) => {
                    this.dashInfosData.dealsWon = response.data
                    this.loadDashSales = false
                })
            },
            getProducts(){
                product.getAll('', '').then( response => {
                   this.dashInfosData.products = response.data.length
                   this.loadDashProducts = false
                })
            },
            getProporsal(){
                const params = {
                    owners: true,
                    count: true
                }
                deal.getAll('', params).then((response) => {
                    this.dashInfosData.deals = this.$mx_numberFormat(response.data)
                    this.loadDashDeals = false
                })
            },
            getReserves(){
                reserve.getAll('', '').then((response) => {
                    this.dashInfosData.reserves = this.$mx_numberFormat(response.data.length)
                    this.loadDashReserves = false
                })
            }
        },
        created(){
            const moment = require('moment')
			require('moment/locale/pt-br')
            this.todaydate = moment().format('[Hoje são] DD [de] MMMM [de] YYYY')
            this.getCustomersFromMonth()
            this.getTasksVisit()
            this.getDealsWon()
            this.getProducts()
            this.getProporsal()
            this.getReserves()
        },
    };
</script>

